import React from 'react';
import PropTypes from 'prop-types';

const ArrowUpIcon = ({ width = '24px', height, className = '', stroke = 'currentColor', fill = 'none' }) => {
  return (
    <svg
      width={width}
      height={height || width}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 19V5M12 5L5 12M12 5L19 12"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ArrowUpIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.string,
};

export default ArrowUpIcon;